import { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { IoMdRemoveCircle } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { uploadImage } from "../../utils/helpers/fileupload";
import { getuserAmenity } from "../../store/slices/amenityhotel";
import { getHotel, updateHotel } from "../../store/slices/hotel";
import {
  emailregex,
  mobileregex,
  nameregex,
  cityregex,
} from "../../utils/Regex";
import { getVendor } from "../../store/slices/vendor";
import { FaImage, FaTrash, FaFileAlt } from "react-icons/fa";
import { getPlace } from "../../store/slices/place";

export default function EditHotelList() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { placeList = [] } = useSelector((state) => state.place);

  // const { vendorList } = useSelector((state) => state.vendor);

  // const vendors = vendorList?.vendors || [];

  const fetchplacedata = () => {
    try {
      dispatch(getPlace());
    } catch (error) {
      console.log(error);
    }
  };

  const convertTo24Hour = (time12h) => {
    if (!time12h) return "";

    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    hours = parseInt(hours, 10);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }

    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  // const fetchvendordata = () => {
  //   try {
  //     const item = { service: "HOTEL" };
  //     dispatch(getVendor(item));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    fetchplacedata();

  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.accessToken;

  const initialForm = {
    name: "",
    city: "",
    location: "",
    address: "",
    email: "",
    contactNumber: "",
    category: "",
    checkInTime: "",
    checkOutTime: "",
    vendor: "",
  };

  const [form, setForm] = useState(initialForm);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [priceList, setPriceList] = useState(null);
  const [pricePreview, setPricePreview] = useState(null);
  const [oldImage, setOldImage] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [addons, setAddons] = useState([{ name: "", type: "", price: "" }]);

  const [addonErrors, setAddonErrors] = useState([]);

  const handleAmenityChange = (name) => {
    setAmenitiesstore((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const { amenitylist = [] } = useSelector((state) => state.amenityuser);

  const [amenitiesstore, setAmenitiesstore] = useState({});


  useEffect(() => {

    const fetchamenitydata = () => {
      try {
        dispatch(getuserAmenity());
      } catch (error) {
        console.log(error);
      }
    };

    fetchamenitydata();
  }, []);

  useEffect(() => {
    const fetchHotel = async () => {
      try {
        const res = await dispatch(getHotel({ id })).unwrap();
        const hotel = res?.data;
        setForm({
          name: hotel?.name || "",
          city: hotel?.city || "",
          location: hotel?.location?._id || "",
          address: hotel?.address || "",
          email: hotel?.email || "",
          contactNumber: hotel?.contactNumber || "",
          category: hotel?.category || "",
          image: hotel?.image || "",
          priceList: hotel?.priceList || "",
          checkInTime: convertTo24Hour(hotel?.checkInTime),
          checkOutTime: convertTo24Hour(hotel?.checkOutTime),
          // vendor: hotel?.vendor?._id,
        });

        const amenityState = {};
        hotel?.amenities?.forEach((id) => {
          amenityState[id] = true;
        });

        setAmenitiesstore(amenityState);

        setPreview(hotel?.image);
        setOldImage(hotel?.image);
        setPricePreview(hotel?.priceList || "");
        if (hotel?.addons?.length > 0) {
          setAddons(
            hotel.addons.map((a) => ({
              name: a.name || "",
              type: a.type || "",
              price: a.price?.toString() || "",
            })),
          );
        } else {
          setAddons([{ name: "", type: "", price: "" }]);
        }
      } catch (err) {
        toast.error("Failed to fetch hotel details");
      }
    };

    if (id) fetchHotel();
  }, [id, dispatch]);



  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };

      switch (name) {
        case "name":
          if (!value.trim()) newErrors.name = "Please enter hotel name";
          else if (!/^[a-zA-Z0-9][\s\S]*$/.test(value))
            newErrors.name = "Please enter valid hotel name";
          else delete newErrors.name;
          break;

        case "city":
          if (!value.trim()) newErrors.city = "Please enter city name";
          else if (!nameregex.test(value))
            newErrors.city = "Please enter valid city name";
          else delete newErrors.city;
          break;

        case "location":
          if (!value.trim()) newErrors.location = "Please select locality";
          else delete newErrors.location;
          break;

        case "vendor":
          if (!value) newErrors.vendor = "Please select vendor";
          else delete newErrors.vendor;
          break;
        case "address":
          if (!value.trim()) newErrors.address = "Please enter address";
          else if (!cityregex.test(value))
            newErrors.address = "Please enter valid address";
          else delete newErrors.address;
          break;

        case "category":
          if (!value) newErrors.category = "Please select star rating";
          else delete newErrors.category;
          break;

        case "email":
          if (!value.trim()) {
            newErrors.email = "Please enter email";
          } else if (value.includes(" ")) {
            newErrors.email = "Email should not contain spaces";
          } else if (value.includes("*")) {
            newErrors.email = "Masked email is not allowed";
          } else if (!emailregex.test(value)) {
            newErrors.email = "Please enter valid email";
          } else {
            delete newErrors.email;
          }
          break;

        case "contactNumber": {
          let numericValue = value.replace(/\D/g, "");

          if (numericValue.length > 10) {
            numericValue = numericValue.slice(0, 10);
          }

          setForm((prev) => ({
            ...prev,
            contactNumber: numericValue,
          }));

          if (!numericValue)
            newErrors.contactNumber = "Please enter contact number";
          else if (numericValue.length !== 10)
            newErrors.contactNumber = "Mobile number must be 10 digits";
          else delete newErrors.contactNumber;

          return newErrors;
        }

        case "checkInTime": {
          setForm((prev) => ({
            ...prev,
            checkInTime: value,
          }));

          if (!value) newErrors.checkInTime = "Please enter check-in time";
          else delete newErrors.checkInTime;

          return newErrors;
        }

        case "checkOutTime": {
          setForm((prev) => ({
            ...prev,
            checkOutTime: value,
          }));

          if (!value) newErrors.checkOutTime = "Please enter check-out time";
          else delete newErrors.checkOutTime;

          return newErrors;
        }

        default:
          break;
      }

      return newErrors;
    });
  };

  const handleAddonChange = (index, field, value) => {
    const updatedAddons = [...addons];
    const updatedErrors = [...addonErrors];
    if (field === "price") {
      value = value.replace(/\D/g, "").slice(0, 5);
    }

    updatedAddons[index][field] = value;

    const { name, type, price } = updatedAddons[index];

    const anyFieldFilled = name || type || price;
    const allFieldsFilled = name && type && price;

    // Initialize error object
    updatedErrors[index] = {};

    if (anyFieldFilled && !allFieldsFilled) {
      if (!name) updatedErrors[index].name = "Please enter addon name";
      if (!type) updatedErrors[index].type = "Please select type";
      if (!price) updatedErrors[index].price = "Please enter price";
    }

    // Validate price format
    if (price && !/^\d{1,7}$/.test(price)) {
      updatedErrors[index].price = "Only numbers allowed (max 7 digits)";
    }

    setAddons(updatedAddons);
    setAddonErrors(updatedErrors);
  };

  // Add -- > addon section
  const handleAddAddon = () => {
    if (addons.length >= 10) {
      alert("Maximum 10 addons allowed");
      return;
    }

    setAddons((prev) => [...prev, { name: "", type: "", price: "" }]);
    setAddonErrors((prev) => [...prev, {}]);
  };

  // Remove <--- addon section
  const handleRemoveAddon = (index) => {
    setAddons((prev) => prev.filter((_, i) => i !== index));
    setAddonErrors((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePriceListChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPriceList(file);
    setPricePreview(URL.createObjectURL(file));
  };

  const removePriceFile = () => {
    setPriceList(null);
    setPricePreview("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(file);
    setPreview(URL.createObjectURL(file));

    setErrors((prev) => {
      const copy = { ...prev };
      delete copy.image;
      return copy;
    });
  };
  const removeImage = () => {
    setImage(null);
    setPreview(null);
    setOldImage("");
  };

  const convertTo12Hour = (time) => {
    if (!time) return "";

    const [hour, minute] = time.split(":");
    let h = parseInt(hour, 10);

    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    h = h ? h : 12;

    return `${h.toString().padStart(2, "0")}:${minute} ${ampm}`;
  };

  const validateAddons = () => {
    let hasError = false;
    const updatedErrors = [];

    addons.forEach((addon, index) => {
      const rowErrors = {};
      const name = addon.name?.trim();
      const type = addon.type?.trim();
      const price = addon.price?.trim();

      const anyFieldFilled = name || type || price;
      const allFieldsFilled = name && type && price;

      // If row is touched but incomplete
      if (anyFieldFilled && !allFieldsFilled) {
        hasError = true;

        if (!name) rowErrors.name = "Please enter addon name";
        if (!type) rowErrors.type = "Please select type";
        if (!price) rowErrors.price = "Please enter price";
      }

      // Validate name format

      // Validate price numeric + range
      if (price && !/^\d{1,7}$/.test(price)) {
        hasError = true;
        rowErrors.price = "Only numbers allowed (max 7 digits)";
      }

      updatedErrors[index] = rowErrors;
    });

    setAddonErrors(updatedErrors);
    return hasError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!form.name?.trim()) newErrors.name = "Please enter hotel name";
    if (!form.city?.trim()) newErrors.city = "Please enter city";
    if (!form.location?.trim()) newErrors.location = "Please select locality";
    // if (!form.vendor) newErrors.vendor = "Please select vendor";
    if (!form.address?.trim()) newErrors.address = "Please enter address";
    if (!form.category) newErrors.category = "Please select star rating";

    if (!form.email?.trim()) {
      newErrors.email = "Please enter email";
    } else if (!emailregex.test(form.email)) {
      newErrors.email = "Please enter valid email";
    }

    if (!form.contactNumber?.trim()) {
      newErrors.contactNumber = "Please enter contact number";
    } else if (!mobileregex.test(form.contactNumber)) {
      newErrors.contactNumber = "Please enter valid mobile number";
    }

    if (!form.checkInTime?.trim())
      newErrors.checkInTime = "Please enter checkInTime ";
    if (!form.checkOutTime?.trim())
      newErrors.checkOutTime = "Please enter checkOutTime ";

    if (!image && !preview) newErrors.image = "Please upload hotel image";

    setErrors(newErrors);
    const hasAddonError = validateAddons();

    if (hasAddonError) return;

    if (Object.keys(newErrors).length > 0) return;

    const selectedAmenities = Object.keys(amenitiesstore).filter(
      (key) => amenitiesstore[key]
    );

    try {
      setLoading(true);

      let fileUrl = oldImage || "";
      let priceFileUrl = pricePreview || "";

      if (image) {
        fileUrl = await uploadImage(image, token);
      }
      if (priceList) {
        priceFileUrl = await uploadImage(priceList, token);
      }

      const payload = {
        id,
        name: form.name.trim(),
        city: form.city.trim(),
        location: form.location.trim(),
        address: form.address.trim(),
        category: form.category,
        email: form.email.trim(),
        contactNumber: form.contactNumber.trim(),
        checkInTime: convertTo12Hour(form.checkInTime),
        checkOutTime: convertTo12Hour(form.checkOutTime),
        image: fileUrl,
        priceList: priceFileUrl,
        addons: addons,
        amenities: selectedAmenities,
        // vendor: form.vendor,
      };

      await dispatch(updateHotel(payload)).unwrap();

      toast.success("Hotel update successfully");

      setForm(initialForm);
      setImage(null);
      setPreview(null);
      setErrors({});

      navigate("/hotel/hotellist");
    } catch (err) {
      toast.error(err || "Failed to update hotel");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">|</span>

          <Link to="/hotel/hotellist" className="breadcrumb-link active">
            Hotel
          </Link>
          <span className="breadcrumb-separator">|</span>
          <span className="breadcrumb-link inactive">Edit Hotel</span>
        </div>
      </div>

      <Container fluid className="p-1 p-md-4">
        <Row>
          <Col xs={12}>
            <Card style={{ borderRadius: "20px", border: "none" }}>
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Hotel Name</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter hotel name"
                            maxLength={50}
                          />
                        </div>

                        {errors.name && (
                          <small className="text-danger">{errors.name}</small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>City</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="city"
                            value={form.city}
                            onChange={handleChange}
                            placeholder="Enter city name"
                            maxLength={50}
                          />
                        </div>

                        {errors.city && (
                          <small className="text-danger">{errors.city}</small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Locality</Form.Label>

                        <Form.Select
                          name="location"
                          value={form.location}
                          onChange={handleChange}
                        >
                          <option value="">Select Locality</option>

                          {placeList?.map((place) => (
                            <option key={place._id} value={place._id}>
                              {place.name}
                            </option>
                          ))}
                        </Form.Select>

                        {errors.location && (
                          <small className="text-danger">
                            {errors.location}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Star Rating</Form.Label>
                        <Form.Select
                          name="category"
                          value={form.category}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option>2 Star</option>
                          <option>3 Star</option>
                          <option>4 Star</option>
                          <option>5 Star</option>
                          <option>Home Stay</option>
                          <option>Villa</option>
                          <option>Budget</option>
                        </Form.Select>
                        {errors.category && (
                          <small className="text-danger">
                            {errors.category}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="contactNumber"
                            value={form.contactNumber}
                            onChange={handleChange}
                            placeholder="Enter contact number"
                          />
                        </div>
                        {errors.contactNumber && (
                          <small className="text-danger">
                            {errors.contactNumber}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            placeholder="Enter email"
                          />
                        </div>
                        {errors.email && (
                          <small className="text-danger">{errors.email}</small>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="address"
                          value={form.address}
                          onChange={handleChange}
                          placeholder="Enter address"
                          style={{ resize: "none" }}
                        />
                        {errors.address && (
                          <small className="text-danger">
                            {errors.address}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Image</Form.Label>

                        <div
                          className="custom-file-uploader"
                          onClick={() =>
                            document.getElementById("imageUpload").click()
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault();
                            const file = e.dataTransfer.files[0];
                            handleImageChange({ target: { files: [file] } });
                          }}
                        >
                          {!preview ? (
                            <div className="upload-placeholder">
                              <div className="upload-icon-box">
                                <FaImage className="upload-icon-white" />
                              </div>
                              <p className="mb-1">Click or Drag Image Here</p>
                            </div>
                          ) : (
                            <div className="image-preview-wrapper">
                              <img
                                src={preview}
                                alt="preview"
                                className="preview-img"
                              />
                              <IoMdRemoveCircle
                                size={24}
                                className="remove-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeImage();
                                }}
                              />
                            </div>
                          )}

                          <Form.Control
                            id="imageUpload"
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            hidden
                          />
                        </div>

                        {errors.image && (
                          <small className="text-danger d-block mt-2">
                            {errors.image}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Price List (PDF)</Form.Label>
                        <Form.Control
                          type="file"
                          accept="application/pdf"
                          onChange={handlePriceListChange}
                        />

                        {errors.price && (
                          <small className="text-danger">{errors.price}</small>
                        )}

                        {pricePreview && (
                          <div
                            className="mt-2 position-relative d-flex align-items-center"
                            style={{ maxWidth: "200px" }}
                          >
                            <FaFileAlt
                              size={50}
                              style={{ cursor: "pointer", color: "#2d0c57" }}
                              onClick={() =>
                                window.open(pricePreview, "_blank")
                              }
                              title="Open Document"
                              className="my-2"
                            />

                            <IoMdRemoveCircle
                              size={25}
                              onClick={removePriceFile}
                              style={{
                                position: "absolute",
                                top: "2px",
                                left: "25px",
                                cursor: "pointer",
                                color: "red",
                                background: "#fff",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                        )}
                      </Form.Group>
                    </Col>


                    <Row className="mb-3">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold mb-2">
                          Amenities
                        </Form.Label>

                        <Row>
                          {amenitylist.map((amenity) => (
                            <Col md={6} key={amenity._id} className="mb-2">
                              <Form.Check
                                type="checkbox"
                                label={amenity.name}
                                checked={amenitiesstore[amenity._id] || false}
                                onChange={() => handleAmenityChange(amenity._id)}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Form.Group>
                    </Row>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Checkin Time</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="time"
                            name="checkInTime"
                            value={form.checkInTime || ""}
                            onChange={handleChange}
                            placeholder="Enter checkInTime"
                          />
                        </div>
                        {errors.checkInTime && (
                          <small className="text-danger">
                            {errors.checkInTime}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Checkout Time</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="time"
                            name="checkOutTime"
                            value={form.checkOutTime || ""}
                            onChange={handleChange}
                            placeholder="Enter checkOutTime"
                          />
                        </div>
                        {errors.checkOutTime && (
                          <small className="text-danger">
                            {errors.checkOutTime}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                    {/* <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vendor</Form.Label>

                        <Form.Select
                          name="vendor"
                          value={form.vendor}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>

                          {vendors.map((vendor) => (
                            <option key={vendor._id} value={vendor._id}>
                              {vendor.name}
                            </option>
                          ))}
                        </Form.Select>

                        {errors.vendor && (
                          <small className="text-danger">{errors.vendor}</small>
                        )}
                      </Form.Group>
                    </Col> */}
                  </Row>

                  <Row>
                    <Col
                      xs={9}
                      className="mt-2 d-flex justify-content-between align-items-center"
                    >
                      <h5>Addons</h5>
                      <Button
                        variant="primary"
                        size="sm"
                        style={{ backgroundColor: "#1e0959", border: "none" }}
                        onClick={handleAddAddon}
                        disabled={addons.length >= 10}
                      >
                        +
                      </Button>
                    </Col>
                  </Row>

                  {addons.map((addon, index) => (
                    <Row key={index} className=" p-1 mt-2">
                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            value={addon.name}
                            maxLength={50}
                            placeholder="Enter name"
                            onChange={(e) => {
                              const value = e.target.value;

                              handleAddonChange(index, "name", value);
                            }}
                          />
                          {addonErrors[index]?.name && (
                            <small className="text-danger">
                              {addonErrors[index].name}
                            </small>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Type</Form.Label>
                          <Form.Select
                            value={addon.type}
                            onChange={(e) =>
                              handleAddonChange(index, "type", e.target.value)
                            }
                          >
                            <option value="">Select Type</option>
                            <option value="PER_PERSON">Per Person</option>
                            <option value="PER_DAY">Per Day</option>
                            <option value="ONE_TIME">One Time</option>
                          </Form.Select>
                          {addonErrors[index]?.type && (
                            <small className="text-danger">
                              {addonErrors[index].type}
                            </small>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>Price</Form.Label>
                          <Form.Control
                            value={addon.price}
                            maxLength={7}
                            placeholder="Enter price"
                            onChange={(e) =>
                              handleAddonChange(index, "price", e.target.value)
                            }
                            pattern="\d{0,7}"
                          />
                          {addonErrors[index]?.price && (
                            <small className="text-danger">
                              {addonErrors[index].price}
                            </small>
                          )}
                        </Form.Group>
                      </Col>

                      {/* Cancel Button */}
                      <Col xs={12} md={1} className="d-flex align-items-center">
                        {addons.length > 1 && (
                          <Button
                            style={{
                              backgroundColor: "#1e0959",
                              border: "none",
                            }}
                            size="sm"
                            onClick={() => handleRemoveAddon(index)}
                            className="mt-3"
                          >
                            <FaTrash />
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}

                  <div className="d-flex mb-5 justify-content-center gap-3 mt-5">
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="light"
                            className="me-2"
                          />
                          Submitting...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
